import React, {useRef, useEffect} from 'react'
import PropTypes from 'prop-types'
import {usePopoverContext} from './popoverContext'
import {PopoverTrigger} from '@/components/ui/popover'
import Icon from 'hec/builder/blocks/icon-picker/icon-picker'
import {cn} from '@/lib/utils'

export const BuilderPopoverTrigger = ({useArrowIcon, iconName, children, attributes}) => {
    const {className, ...restAttributes} = attributes
    const {setPopoverOpen, popoverOpen, handleMouseLeave} = usePopoverContext()

    const popoverTriggerRef = useRef(null)

    const useIcon = useArrowIcon && iconName

    useEffect(() => {
        if (popoverTriggerRef.current && useIcon) {
            const svg = popoverTriggerRef.current.querySelector(`[data-icon-name="${iconName}"]`)
            if (svg) {
                svg.style.transform = popoverOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                svg.style.transition = 'transform 0.3s ease'
            }
        }
    }, [popoverOpen, useIcon, iconName])
    return (
        <PopoverTrigger
            ref={popoverTriggerRef}
            onMouseEnter={() => setPopoverOpen(true)}
            onMouseLeave={handleMouseLeave}
            onClick={() => setPopoverOpen(!open)}
            className={cn('flex items-center justify-center space-x-2', className)}
            {...restAttributes}
            data-testid="popoverTrigger-PopoverTrigger"
        >
            {children}
            {useIcon && (
                <Icon
                    iconName={iconName}
                    data-icon-name={iconName}
                    data-testid="popoverTrigger-Icon"
                />
            )}
        </PopoverTrigger>
    )
}

BuilderPopoverTrigger.propTypes = {
    attributes: PropTypes.object.isRequired,
    children: PropTypes.node,
    useArrowIcon: PropTypes.bool,
    iconName: PropTypes.string
}

export const PopoverTriggerDefinition = {
    component: BuilderPopoverTrigger,
    name: 'PopoverTrigger',
    noWrap: true,
    hideFromInsertMenu: true,
    canHaveChildren: true,
    inputs: [
        {
            name: 'useArrowIcon',
            type: 'boolean',
            defaultValue: false,
            helperText: 'An arrow icon that will rotate when the popup is expanded.'
        },
        {
            name: 'iconName',
            type: 'string',
            enum: ['ArrowDown'],
            defaultValue: 'ArrowDown',
            showIf: `options.get('useArrowIcon') === true`
        }
    ]
}
